import SimpleSelect from 'components/SimpleSelect';
import { sampleRandomColorFromPalette } from 'constants/colorPalette';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import type { Client, ClientDraft } from 'types/client';

interface NormalizedClient {
  label: string;
  value: number;
}

interface Props {
  value: number | null | undefined;
  className?: string;
  onChange: (clientId: number, client: Client) => void;
  clients: Array<Client>;
  saveClient: (props: ClientDraft) => Promise<Client>;
  canCreate?: boolean;
}

export default class ClientSelect extends Component<Props> {
  clientsNormalized(clients: Array<Client>): Array<NormalizedClient> {
    return clients.map(client => {
      return {
        value: client.id,
        label: client.name,
        icon: <FontAwesome name="circle" style={{ color: '#' + client.color }} />,
      };
    });
  }

  handleCreate = (name: string) => {
    if (name.length === 0) {
      return;
    }

    const client: ClientDraft = { name, color: sampleRandomColorFromPalette() };

    this.props.saveClient(client).then(client => {
      this.props.onChange?.(client.id, client);
    });
  };

  handleChange = (value: number) => {
    if (this.props.onChange) {
      const client = this.props.clients.find(client => client.id === value);
      if (client) {
        this.props.onChange(value, client);
      }
    }
  };

  render() {
    const options = this.clientsNormalized(this.props.clients);

    const createProps = this.props.canCreate
      ? {
          onCreate: this.handleCreate,
          onCreatePlaceholder: 'Add new client by typing...',
        }
      : {};

    return (
      <div className={this.props.className}>
        <SimpleSelect
          hideFromFullstory
          value={this.props.value == null ? null : this.props.value}
          placeholder="Client name..."
          options={options}
          onChange={this.handleChange}
          {...createProps}
        />
      </div>
    );
  }
}
